import { type ApolloClient, type NormalizedCacheObject } from '@apollo/client'
import {
  type GetSearchResultsPageByUrlWithSeoQuery,
  type GetSearchResultsPageByUrlWithSeoQueryVariables,
  GetSearchResultsPageByUrlWithSeoDocument,
} from '@kijiji/generated/graphql-types'

import { getPaginationFromUrl } from '@/domain/srp/pagination/getPaginationFromUrl'
import { type DecodedLocation } from '@/domain/srp/urlDecode'
import { type CustomContext } from '@/types/apollo'

export type SeoRequiredInputs = {
  categoryId: string
  location: DecodedLocation
  keywords: string | undefined
}

/*
  Gets the data for initial page load on SRP for SEO crawlers.

  See https://developers.google.com/search/docs/crawling-indexing/javascript/dynamic-rendering
*/
export const getResultsByUrl = async (
  url: string,
  apolloClient: ApolloClient<NormalizedCacheObject>,
  seoRequiredInputs: SeoRequiredInputs,
  context?: CustomContext
) => {
  const pagination = getPaginationFromUrl(url)

  return await apolloClient.query<
    GetSearchResultsPageByUrlWithSeoQuery,
    GetSearchResultsPageByUrlWithSeoQueryVariables
  >({
    query: GetSearchResultsPageByUrlWithSeoDocument,
    variables: {
      searchResultsByUrlInput: {
        url: url,
        pagination,
      },
      pagination,
      searchUrlPopularInput: {
        categoryId: seoRequiredInputs.categoryId,
        keywords: seoRequiredInputs.keywords,
        location: {
          id: seoRequiredInputs.location.id,
        },
      },
    },
    fetchPolicy: 'network-only',
    errorPolicy: 'all',
    context: {
      ...context,
    },
  })
}
